/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../routes/__root'
import { Route as IndexRouteImport } from './../../routes/index'
import { Route as PracticeMembersRouteImport } from './../../routes/practice-members'
import { Route as ReportingRouteImport } from './../../routes/reporting'
import { Route as SignInRouteImport } from './../../routes/sign-in'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PracticeMembersRoute = PracticeMembersRouteImport.update({
  id: '/practice-members',
  path: '/practice-members',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportingRoute = ReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/practice-members': typeof PracticeMembersRoute
  '/reporting': typeof ReportingRoute
  '/sign-in': typeof SignInRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/practice-members': typeof PracticeMembersRoute
  '/reporting': typeof ReportingRoute
  '/sign-in': typeof SignInRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/practice-members': typeof PracticeMembersRoute
  '/reporting': typeof ReportingRoute
  '/sign-in': typeof SignInRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/practice-members' | '/reporting' | '/sign-in'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/practice-members' | '/reporting' | '/sign-in'
  id: '__root__' | '/' | '/practice-members' | '/reporting' | '/sign-in'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PracticeMembersRoute: typeof PracticeMembersRoute
  ReportingRoute: typeof ReportingRoute
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/practice-members': {
      id: '/practice-members'
      path: '/practice-members'
      fullPath: '/practice-members'
      preLoaderRoute: typeof PracticeMembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting': {
      id: '/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof ReportingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PracticeMembersRoute: PracticeMembersRoute,
  ReportingRoute: ReportingRoute,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
